/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'classnames';
import IconAngleSmall from '@src/components/Icon/set/IconAngleSmall';

import css from '../style.module.scss';

const ButtonRightArrow = (props) => {
	const { className, mods, disabled, ...rest } = props;
	return (
		<span
			className={cn(css.btnArrow, css.btnArrow_right, className, mods, {
				[css.btnArrow_disabled]: disabled,
			})}
			{...rest}
		>
			<IconAngleSmall />
		</span>
	);
};

export default ButtonRightArrow;
